import { isNewStatus as isNewStatusSelector } from 'app/App/selectors/editStatus';
import componentRenderingEnvSelector from 'app/Canvas/selectors/componentRenderingEnv';
import {
  checkStatusAndVisitFolderThunk as checkStatusAndVisitFolder,
  changePagePropertyDetail
} from 'app/Explorer/thunks';
import isPageSelectedSelector from 'app/Page/selectors/isPageSelected';
import pageTemplateNameSelector from 'app/Page/selectors/pageTemplateName';
import pageTypeSelector from 'app/Page/selectors/pageType';
import { setRenderingEnv } from 'app/RenderingEnvironment/actions';
import { visitFolder } from 'app/Router/actions';
import cwdDetailsSelector from 'app/Tree/selectors/cwdDetails';
import preferredHomeFolderIdSelector from 'app/UserInfo/selectors/preferredHomeFolderId';
import connect from 'utils/store/connect';

import Breadcrumb from './components/Breadcrumb';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
const mapStateToProps = state => ({
  cwdDetails: cwdDetailsSelector(state),
  isNewStatus: isNewStatusSelector(state),
  isPage: isPageSelectedSelector(state),
  pageTemplateName: isPageSelectedSelector(state)
    ? pageTemplateNameSelector(state)
    : componentRenderingEnvSelector(state).PageTemplateName,
  pageType: isPageSelectedSelector(state)
    ? pageTypeSelector(state)
    : componentRenderingEnvSelector(state).PageType,
  userHomeFolderId: preferredHomeFolderIdSelector(state)
});

const mapDispatchToProps = {
  changePagePropertyDetail,
  checkStatusAndVisitFolder,
  setRenderingEnv,
  visitFolder
};
export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);
